module.exports = __webpack_public_path__ + "img/ALIYUN_RAM_ROLE.4cf3475e.png";